import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
const api = '/api/'

export const stockStatistics = createAsyncThunk('canteen-stock-statistics', async (_, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}canteen/stock-statistics`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const itemsList = createAsyncThunk('canteen-items-list', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}canteen/items-list`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const itemsStatistics = createAsyncThunk(
  'canteen-items-statistics',
  async (params: {}, thunkAPI) => {
    try {
      // Send GET request with query parameters
      const {data} = await axios.get(`${api}canteen/items-statistics`, {params})
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const cashStatistics = createAsyncThunk('canteen-cash-statistics', async (_, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}canteen/cash-statistics`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

type DashboardState = {
  errors: any
}

const initialState: DashboardState = {
  errors: '',
}

export const dashboardSlice = createSlice({
  name: 'item',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
})

export const {reset} = dashboardSlice.actions
export default dashboardSlice.reducer
